import React from "react";
import { Result } from "antd";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CustomButton from "../../components/CustomButton";
import styles from "./OrderSuccess.module.css";

export const OrderSuccess: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { orderId } = useParams();
  const orderStatus = (location.state as any)?.orderStatus;
  const orderAuditStatus = (location.state as any)?.orderAuditStatus;

  const handleGoToRiskAssessment = () => {
    navigate(`/orders/${orderId}/risk`);
  };

  const handleBackToOrderList = () => {
    navigate("/orders");
  };

  const handleViewOrderDetails = () => {
    navigate(`/orders/${orderId}`, {
      state: {
        readOnly: true,
        orderStatus,
        orderAuditStatus,
      },
    });
  };

  return (
    <div className={styles.container}>
      <Result
        status="success"
        title="訂單簽署檔案完成!"
        subTitle="您現在可以"
        extra={[
          <CustomButton key="risk" height={40} fontSize={16} bgColor="var(--theme-primary)" color="#fff" onClick={handleGoToRiskAssessment} block className={styles.primaryButton}>
            去填寫風險評估問卷
          </CustomButton>,
          <div key="actions" className={styles.actionButtons} style={{ display: "flex", justifyContent: "center", gap: "16px", marginTop: "16px" }}>
            <CustomButton height={40} fontSize={16} bgColor="#fff" color="#666" style={{ border: "1px solid #d9d9d9" }} onClick={handleBackToOrderList}>
              返回訂單紀錄
            </CustomButton>
            <CustomButton height={40} fontSize={16} bgColor="#fff" color="#666" style={{ border: "1px solid #d9d9d9" }} onClick={handleViewOrderDetails}>
              查看訂單詳情
            </CustomButton>
          </div>,
        ]}
      />
    </div>
  );
};

// Simple styles if css module is not set up, but we will try to use inline styles or existing common styles if possible.
// However, the user uses css modules. I should create the css file as well.
